/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItem_user$ref = any;
export type PdpRespComplementaryItemsGrid_user$ref = any;
export type PdpRespComplementaryItemsGrid_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": PdpRespSimilarItem_user$ref;
    readonly " $refType": PdpRespComplementaryItemsGrid_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespComplementaryItemsGrid_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSimilarItem_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'ee3e5955eb96313f940b13f49e4296ec';
export default node;
